export default __webpack_public_path__ + "static/media/logo.e6a56521.png";